var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
// Imports
import Vue from "vue";
import Component from "vue-class-component";
import moment from "moment";
import { Handicap } from "../../modules/handicap";
import { Utilities } from "../../services/utilities";
// Define vue parameters
var EditHandicapComponent = /** @class */ (function (_super) {
    __extends(EditHandicapComponent, _super);
    /**
     * Setup the child and parent class
     */
    function EditHandicapComponent() {
        var _this = _super.call(this) || this;
        // Create a clubs instance
        _this.handicap = new Handicap();
        return _this;
    }
    /**
     * Component setup on mount
     */
    EditHandicapComponent.prototype.mounted = function () {
        var _this = this;
        Utilities.toggleModalActiveClass(true);
        // Get handicap
        this.handicap
            .specific(this.$props.handicapId)
            .then(function (r) {
            _this.$data.handicapData = r;
            _this.$data.loading = false;
        })
            .then(function () {
            _this.handicap
                .getTeeTypesForCourse(_this.$data.handicapData.courseId)
                .then(function (rr) {
                rr.forEach(function (tee) {
                    _this.$data.teeTypes.push({
                        teeTypeId: tee.teeTypeId,
                        teeType: tee.teeType,
                        teeColorTypeId: tee.teeColorTypeId,
                        teeColorType: tee.teeColorTypeId
                    });
                });
            });
        });
    };
    EditHandicapComponent.prototype.destroyed = function () {
        Utilities.toggleModalActiveClass(false);
    };
    EditHandicapComponent.prototype.formatDate = function (date) {
        return moment(date).format("M/D/YY");
    };
    EditHandicapComponent.prototype.deleteHandicap = function () {
        var _this = this;
        Utilities.confirm("Are you sure you want to remove this round from your handicap?").then(function () {
            _this.handicap["delete"](_this.$props.playerId, _this.$props.handicapId)
                .then(function (r) {
                // @TODO - reload data without refreshing page
                window.location.href =
                    "/players/" +
                        _this.$props.playerId +
                        "/handicap" +
                        Utilities.getIframeParam();
            });
        });
    };
    EditHandicapComponent.prototype.hide = function () {
        this.$modal.hide("edit-handicap");
    };
    EditHandicapComponent.prototype.updateEntry = function () {
        var _this = this;
        // Reset errors
        this.$data.totalScoreError = null;
        this.$data.courseRatingError = null;
        this.$data.courseSlopeError = null;
        // Do error checking
        if (isNaN(this.$refs.adjustedGrossScoreReference
            .value) ||
            this.$refs.adjustedGrossScoreReference
                .value === "") {
            this.$data.totalScoreError = "Must be a number";
            return false;
        }
        if (isNaN(this.$refs.courseRatingReference.value) ||
            this.$refs.courseRatingReference.value === "") {
            this.$data.courseRatingError = "Must be a number";
            return false;
        }
        if (isNaN(this.$refs.courseSlopeReference.value) ||
            this.$refs.courseSlopeReference.value === "") {
            this.$data.courseSlopeError = "Must be a number";
            return false;
        }
        if (this.$refs.adjustedGrossScoreReference.value <
            0) {
            this.$data.totalScoreError = "Cannot be negative";
            return false;
        }
        if (this.$refs.courseRatingReference.value < 0) {
            this.$data.courseRatingError = "Cannot be negative";
            return false;
        }
        if (this.$refs.courseSlopeReference.value < 0) {
            this.$data.courseSlopeError = "Cannot be negative";
            return false;
        }
        this.handicap
            .update(this.$props.handicapId, this.$refs.adjustedGrossScoreReference
            .value, this.$refs.teeTypeReference.value, this.$refs.courseRatingReference.value, this.$refs.courseSlopeReference.value, this.$data.handicapData.courseName)
            .then(function (r) {
            _this.$modal.hide("edit-handicap");
            // @TODO - reload data without refreshing page
            window.location.href =
                "/players/" +
                    _this.$props.playerId +
                    "/handicap" +
                    Utilities.getIframeParam();
        });
    };
    EditHandicapComponent = __decorate([
        Component({
            props: ["playerId", "handicapId"],
            data: function () {
                return {
                    handicapData: null,
                    teeTypes: [],
                    loading: true,
                    totalScoreError: null,
                    courseSlopeError: null,
                    courseRatingError: null
                };
            }
        })
        // Define the component code
    ], EditHandicapComponent);
    return EditHandicapComponent;
}(Vue));
export default EditHandicapComponent;
